import { axiosApi } from "../../../../../../../api/dbAxios";

export const addFavoriteItem = async (code: string, case_no: string) => {
  try {
    const response = await axiosApi.post(`/favorite/`, { code, case_no });
    return response.data;
  } catch (error) {
    console.error("Error creating favorite item:", error);
    return {};
  }
};
